import { useMutation } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';

const useRegisterSupport = () => {
  const { token } = useContext(AuthContext);

  const registerSupport = async (formData) => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/users/register/support`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error('Support registration failed');
    }

    return response.json();
  };

  return useMutation(registerSupport);
};

export default useRegisterSupport;
